import { ApiError } from '../../shared/api/ApiClient.js';

export const CustomerAuthErrorCodes = {
  TRANSACTION_LINKED_TO_OTHER_CUSTOMER: 'TRANSACTION_LINKED_TO_OTHER_CUSTOMER',
} as const;

export function linkAccountIdempotencyKey(paymentId: string, customerId: number): string {
  return `customer-link-account:${paymentId}:${customerId}`;
}

export function isTransactionLinkedToOtherCustomerError(error: Error): boolean {
  return (
    error instanceof ApiError &&
    error.code === CustomerAuthErrorCodes.TRANSACTION_LINKED_TO_OTHER_CUSTOMER
  );
}
